var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99839 14.5049C6.99839 14.5049 7.68944 11.6237 8.94367 9.96589C13.0191 4.57901 22.1332 4.98889 26.4903 9.33357C27.2701 10.1134 27.889 10.9675 28.3965 11.8834",
    stroke: "#8A96A3",
    strokeWidth: 3.24214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0755 13.8569H30.5273V7.40512",
    stroke: "#8A96A3",
    strokeWidth: 3.24214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7145 24.1562C30.7145 24.1562 30.0235 27.0374 28.7692 28.6952C24.6938 34.0821 15.5797 33.6722 11.2226 29.3276C10.4428 28.5477 9.8239 27.6937 9.31641 26.7777",
    stroke: "#8A96A3",
    strokeWidth: 3.24214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6374 24.8042H7.18555V31.256",
    stroke: "#8A96A3",
    strokeWidth: 3.24214,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.565378c69d8e4ca298c2212f8da03a4d.svg";
export { ForwardRef as ReactComponent };